module.exports = __webpack_public_path__ + "img/projectIntroductionImg.ea49495d.png";